import { EnrollmentState } from 'src/graphql.generated'

// Standard's participant-list labels (`participantsView/constants.ts`), which this directory can't import, in its order.
const ENROLLMENT_STATE_LABELS: Record<EnrollmentState, string> = {
  [EnrollmentState.IntakePreRegistered]: 'Pre-registered',
  [EnrollmentState.IntakeRegistered]: 'Registered',
  [EnrollmentState.IntakeLoggedIn]: 'Logged In',
  [EnrollmentState.IntakeCallScheduled]: 'Call Scheduled',
  [EnrollmentState.InProgram]: 'In Program',
  [EnrollmentState.CancellationPending]: 'Cancellation Pending',
  [EnrollmentState.PostProgram]: 'Post Program',
  [EnrollmentState.DidNotStart]: 'Did Not Start',
  [EnrollmentState.Test]: 'Test',
}

export const ENROLLMENT_STATES = (Object.keys(ENROLLMENT_STATE_LABELS) as EnrollmentState[]).map((id) => ({
  id,
  label: ENROLLMENT_STATE_LABELS[id],
}))
